module.exports = __webpack_public_path__ + "static/media/mental.27967ef9.png";